import api from "./axios";
import { paths } from "./paths";

export interface TeamAssignment {
  playerId: string;
  teamId: number;
}

export const generateTeams = (playerIds: string[]) =>
  api
    .post<TeamAssignment[]>(paths.teams.generate, { playerIds })
    .then((r) => r.data);
